import React from "react";
import { usePermission } from "../../hooks/usePermission";
import useAuth from "../../hooks/useAuth";

export default function PermissionGate({
  permission,
  fallback = null,
  children,
}) {
  const { loading } = useAuth();
  const has = usePermission(permission);

  if (loading) return null;

  if (has) {
    return <>{children}</>;
  }

  return fallback || null;
}
